import { render, staticRenderFns } from "./desktopDeclination2.vue?vue&type=template&id=62d65b76&scoped=true&"
import script from "./desktopDeclination2.vue?vue&type=script&lang=ts&"
export * from "./desktopDeclination2.vue?vue&type=script&lang=ts&"
import style0 from "./desktopDeclination2.vue?vue&type=style&index=0&id=62d65b76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d65b76",
  null
  
)

export default component.exports